export default __webpack_public_path__ + "static/media/danger.f5ff5eb8.svg";